(function () {
    'use strict';

    var module = angular.module('uwAgenda.agenda');
    /* directive for handling daytask reactions in agenda */
    module.directive('agendaDaytaskReactions', [function () {
        var directive = {
            restrict: 'E',
            templateUrl: '/app/agenda/templates/agenda-daytask-reactions.template.html'           
        };
        return directive;

    }]);
})();